import React, { useState } from 'react';
import _uniqueId from 'lodash/uniqueId';

export default function FieldTextarea({
  label,
  placeholder,
  information,
  value,
  style,
  onChange,
  onKeyDown,
  resize = false,
  required = false,
  disabled = false,
  readonly = false,
  classNames = '',
  maxLength = 255,
  error,
  inputClassName,
  rows = 5,
  name,
}) {
  const [id] = useState(_uniqueId('field_'));

  return (
    <div className={'form-group ' + classNames} style={style}>
      {label && <label htmlFor={id}>{label}</label>}
      <textarea
        rows={rows}
        name={name}
        maxLength={maxLength}
        value={value || ''}
        className={`form-control ${inputClassName}`}
        id={id}
        placeholder={placeholder}
        aria-describedby={id + 'Help'}
        onChange={onChange}
        onKeyDown={onKeyDown}
        readOnly={readonly}
        disabled={disabled}
        required={required}
        style={{ resize: resize ? 'both' : 'none' }} // <-- FIXED
      ></textarea>
      {information ? (
        <small id={id + 'Help'} className='form-text text-muted'>
          {information}
        </small>
      ) : null}
      {error ? (
        <div className='invalid-feedback' style={{ display: 'block' }}>
          {error}
        </div>
      ) : null}
    </div>
  );
}
